import * as React from 'react'
import dynamic from 'next/dynamic'

import {Hero, About, Testimonial, Why, Solutions, Demos} from '@components/ai'
import {AILayout} from '@components/ai'

const Meta = dynamic(() => import('@components/Meta'))
export default function AIConsultation() {
  return (
    <div>
      <Meta title='AI Consultation | Datawow – Data Science Consultant Thailand | Data Wow in Bangkok' />
      <Hero />
      <About />
      <Testimonial />
      <Why />
      <Solutions />
      <Demos />
    </div>
  )
}

AIConsultation.getLayout = function getLayout(page: React.ReactElement) {
  return <AILayout>{page}</AILayout>
}
